import { apiMerchant } from "@/api";

import { parseBestsellersResponse, type BestsellerEntry } from "./bestseller";

/**
 * WHERE THE STOREFRONT READS THE BESTSELLERS RANKING
 *
 * Read-only, like `StorefrontAppearanceSource`: ranking is computed backend-side
 * over all store orders; the customer storefront has nothing to write back.
 */
export interface BestsellersSource {
  /**
   * Never rejects. Bestsellers are a showcase, not essential data. Network/404/
   * corrupt payload all become an empty list — same as "fewer than 3 hits".
   */
  get(merchantId: string): Promise<BestsellerEntry[]>;
}

/**
 * Public GET `/merchants/:id/bestsellers`. `apiMerchant` already ends in
 * `/merchants`.
 */
export class HttpBestsellersSource implements BestsellersSource {
  async get(merchantId: string): Promise<BestsellerEntry[]> {
    try {
      const { data } = await apiMerchant.get<unknown>(`/${encodeURIComponent(merchantId)}/bestsellers`);
      return parseBestsellersResponse(data);
    } catch {
      return [];
    }
  }
}

/** Sole composition point — no flag; no alternate source today. */
export const bestsellersSource: BestsellersSource = new HttpBestsellersSource();
